<template>
    <div id="contacts" class="section"> 
      <span v-if="language==='EN'">
          <PageTitle :title="'Contacts'" :subtitle="'YOU CAN CONTACT OKSANA HERE'" :description="''" />
          <v-card>
              <v-card-text>
                <p class="anonce">For all your questions!</p>
                <p>Please send e-mail: <span class="anonce">oksana. kowcz @ gmail .com</span></p>
              </v-card-text>
          </v-card>  
      </span>
      <span v-if="language==='RU'">
          <PageTitle :title="'Контакты'" :subtitle="'ВЫ МОЖЕТЕ СВЯЗАТЬСЯ С ОКСАНОЙ ЗДЕСЬ'" :description="''" />
          <v-card>
              <v-card-text>
                <p class="anonce">По всем вопросом!</p>
                <p>Вы можете связаться с Оксаной по e-mail: <span class="anonce">oksana. kowcz @ gmail .com</span> </p>          
              </v-card-text>
          </v-card>
      </span>
      <span v-if="language==='UA'">
          <PageTitle :title="'Зв\'язок'" :subtitle="'ВИ МОЖЕТЕ ЗВ\'ЯЗАТИСЬ З ОКСАНОЮ ТУТ'" :description="''" />
          <v-card>
              <v-card-text>
                <p class="anonce">З будь-яких питань!</p>
                <p>Ви можете зв'язатись з Оксаною по e-mail: <span class="anonce">oksana. kowcz @ gmail .com</span></p>            
              </v-card-text>
          </v-card>  
      </span>  
        <v-layout>
           <v-spacer></v-spacer>
               <div class="mt-3">  &copy; Oksana Kowcz 2013 - {{ new Date().getFullYear() }}</div>            
        </v-layout>
    </div> 
</template>

<script>
    import PageTitle from '@/components/PageTitle'
    import { MyFunctions } from '@/data/functions.js'
    
    export default {
    name: 'Portfolio',
       components: { PageTitle },
       data: () => ({
           language: ''
       }),
        mounted(){
            this.language = MyFunctions.getLanguage()
        },
    }
</script>

<style>
    #contacts .anonce {
      color: #339900!important;
      font-size: 18px;
      font-family: 'Open Sans Condensed', sans-serif!important;
    }
</style>